import Mediator from 'common/scripts/mediator';

const mediator = new Mediator();

const upClass = 'is-up';
const hideClass = 'is-hide';
const showClass = 'is-show';
const hideMobClass = 'is-hide-mob';

/**
 * добавление счетчика вверх страницы
 */

class Countdown {
    constructor() {
        this.parent = {};
        this.parentHeight = null;
        this.countdownDate = '';
        this.interval = {};
        this.layout = document.querySelector('.l-layout__content');
        this.header = document.querySelector('.l-layout__header');
        this.subheader = document.querySelector('.subheader');
    }

    /**
     * инициализация счетчика
     * @param {Object} options - опции
     */
    init(options) {
        this.parent = options.parent;
        this.isMobileHide = options.isMobileHide;
        const date = this.parent.dataset.date;
        const sessionName = options.sessionName;
        const closeBtn = this.parent.querySelector('.j-countdown-close');

        if (date) {
            this.countdownDate = new Date(this.parent.dataset.date).getTime();
            this.startCount();
        }
        this.show();
        this.setHeight();
        this.changePosition();
        window.addEventListener('resize', () => {
            if (!this.parent.classList.contains(hideClass)) {
                this.parent.classList.remove(upClass);

                return this.setHeight();
            }

            return true;
        });
        closeBtn.addEventListener('click', () => {
            this.setSession(sessionName);

            return this.removeCountdown();
        });
    }

    show() {
        this.parent.classList.add(showClass);

        if (this.isMobileHide) {
            this.parent.classList.add(hideMobClass);
        }
    }

    /**
     * метод берет высоту счетчика и сдвигает layout, хедер и сабхедер на эту высоту
     */
    setHeight() {
        this.parentHeight = this.parent.offsetHeight;

        this.layout.style.marginTop = `${this.parentHeight}px`;
        if (this.header) {
            this.header.style.top = `${this.parentHeight}px`;
        }
        if (this.subheader) {
            this.subheader.style.top = `${this.parentHeight}px`;
        }

        this.parent.style.top = '0px';
    }

    /**
     * метод запускает счетчик
     */
    startCount() {
        const daysElement = this.parent.querySelector('.j-days');
        const hoursElement = this.parent.querySelector('.j-hours');
        const minutesElement = this.parent.querySelector('.j-minutes');

        this.interval = setInterval(() => {
            const now = new Date().getTime();
            const distance = this.countdownDate - now;
            const days = Math.floor(distance / (1000 * 60 * 60 * 24));
            const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            // const seconds = Math.floor((distance % (1000 * 60)) / 1000);

            daysElement.innerHTML = days;
            hoursElement.innerHTML = hours;
            minutesElement.innerHTML = minutes;

            // если время истекло
            if (distance < 0) {
                clearInterval(this.interval);
            }
        }, 1000);
    }

    setSession(name) {
        sessionStorage.setItem(name, 'true');
    }

    /**
     * метод удаляет счетчик, Öбнуляет
     */
    removeCountdown() {
        const height = '0px';

        this.parent.style.top = `-${this.parent.offsetHeight * 2}px`;
        this.layout.style.marginTop = height;

        if (this.header) {
            this.header.style.top = height;
        }
        if (this.subheader) {
            this.subheader.style.top = height;
        }

        this.parent.classList.add(hideClass);

        mediator.publish('removeCountdown');

        clearInterval(this.interval);
    }

    changePosition() {
        // текущая позиция скролла
        let scrollPosition = 0;

        document.addEventListener('scroll', () => {
            if (this.parent.classList.contains(hideClass)) {
                return;
            }

            const scrollTopPosition = window.pageYOffset;
            const isMobile = window.matchMedia('(max-width: 669px)').matches;

            this.scrollBottom(scrollPosition, isMobile, scrollTopPosition);
            this.scrollTop(scrollPosition, isMobile, scrollTopPosition);

            scrollPosition = scrollTopPosition;
        });
    }

    scrollBottom(scrollPosition, isMobile, scrollTopPosition) {
        // шаг времени задержки отрабатывания функции отображения хэдера
        const stepScrollBottom = 5;
        const heightWindow = window.innerHeight;

        /**
         * Cкролл вниз при условии, что прошла высота хэдера для мобильного или высота экрана для десктопа
         */
        const mobileConditionHiding = isMobile && (scrollTopPosition > 0);
        const desktopConditionHiding = !isMobile && (scrollTopPosition > heightWindow) &&
          ((scrollTopPosition - scrollPosition) > stepScrollBottom);

        if (mobileConditionHiding || desktopConditionHiding) {
            this.parent.classList.add(upClass);

            if (this.header) {
                this.header.style.top = `0px`;
            }
            if (this.subheader) {
                this.subheader.style.transform = `translateY(-${this.parentHeight}px)`;
            }
        }
    }

    scrollTop(scrollPosition, isMobile, scrollTopPosition) {
        // шаг времени задержки отрабатывания функции скрытия хэдера
        const stepScrollTop = -5;

        /**
         * Cкролл вверх при условии, что доскролили до высота хэдера для мобильного или просто скролл вверх для десктопа
         */
        const mobileConditionShowing = isMobile && (scrollTopPosition < this.parentHeight);
        const desktopConditionShowing = !isMobile && ((scrollTopPosition - scrollPosition) < stepScrollTop);

        if (mobileConditionShowing || desktopConditionShowing) {
            this.parent.classList.remove(upClass);
            if (this.header) {
                this.header.style.top = `${this.parentHeight}px`;
            }
            if (this.subheader) {
                this.subheader.style.transform = 'translateY(0)';
                const subMenu = this.subheader.querySelector('.j-submenu');

                if (subMenu.classList.contains('is-active')) {
                    subMenu.classList.remove('is-active');
                }
            }
        }
    }
}

export default Countdown;
